import React, { Fragment, useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Modal from '../../shared/components/Modal';
import GraphQl from '../../GraphQL';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import MatTable from '../../shared/components/material-table';
import columns from './components/Columns';
import {
  communicationListForAnalysis,
  sendCommunicationsByIds,
  communicationRemoveQuery,
} from '../../shared/queries/Communication';
import {
  getFormattedDate,
  updatePendency,
} from '../../shared/utils/smartutils';
import { ACTION_NAME } from '../../shared/utils/constants';

const PeriodicAnalysis = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const [sent, setSent] = useState(false);
  const [analysisToSend, setAnalysisToSend] = useState(false);
  const { t, history, dispatch } = props;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const toggleModal = () => {
    if (sent) {
      setSent(!sent);
    }
    setModal(!modal);
  };

  const sendAll = (evt, rowData) => {
    setAnalysisToSend(rowData);
    setSent(!sent);
    toggleModal();
  };

  const loadAllAnalysis = () => {
    const query = communicationListForAnalysis();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.communicationListByFilter = res.communicationListByFilter.map(
          (item) => ({
            ...item,
            formattedDate: getFormattedDate(new Date(item.createdAtMili)),
            formattedSent: t(`general.yesno.${item.sent}`),
            student: item.relatedObjects[0].description,
            auditStatus: t(`audit-status.${item.timelineIntegrationStatus}`),
          })
        );
        setData(res.communicationListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const deleteItemMutation = () => {
    toggleModal();
    showLoading();
    const removeMutation = communicationRemoveQuery(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch((error) => {
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
        loadAllAnalysis();
        updatePendency(dispatch);
      });
  };

  const addItemClickHandler = () => {
    history.push('/minime/analise/mnt/0');
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({ ...rowData });
    toggleModal();
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({ ...rowData });
    history.push(`/minime/analise/mnt/${rowData.id}`);
  };

  const sentSubmit = () => {
    toggleModal();
    showLoading();
    const communicationIdsToSend = analysisToSend
      .filter((analysis) => !analysis.sent)
      .map((analysis) => analysis.id);
    const mutation = sendCommunicationsByIds(communicationIdsToSend);
    GraphQl(mutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch((error) => {
        console.error(error);
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
        loadAllAnalysis();
      });
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find((a) => a.name === ACTION_NAME.EDIT).hidden =
        propss.data.sent;
      copyProps.actions.find((a) => a.name === ACTION_NAME.VIEW).hidden =
        !propss.data.sent;
    }
  };

  const customActions = [
    {
      name: ACTION_NAME.VIEW,
      icon: () => <VisibilityIcon />,
      tooltip: t('general.view'),
      onClick: editItemClickHandler,
      position: 'row',
    },
  ];

  useEffect(() => {
    loadAllAnalysis();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={
          sent
            ? t('notifications.submit-reviews-not-changed')
            : t('notifications.delete_modal')
        }
        toggle={toggleModal}
        modal={modal}
        onConfirm={() => (sent ? sentSubmit() : deleteItemMutation())}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    columns={columns(t)}
                    pageSize={20}
                    deleteAction={removeItemClickHandler}
                    onRefreshClick={loadAllAnalysis}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                    customActions={customActions}
                    actionsDisabledByConditional={actionsDisabledByConditional}
                    onSentClick={sendAll}
                    title={t('panels.periodic-analysis')}
                    selection
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

PeriodicAnalysis.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(PeriodicAnalysis)
);
